import { gql } from '@apollo/client'

export const DELETE_VACCINATION_RECORD = gql`
  mutation DeleteVaccinationRecord($inputData: DeleteVaccinationRecordInput!) {
    deleteVaccinationRecord(inputData: $inputData)
  }
`
